<ng-container [formGroup]="formParent">
  <div class="form-field-container">
    <mat-checkbox
      class="easy-checkbox"
      [formControlName]="name"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
      [class.required]="required && !hideRequiredLabel"
      [(ngModel)]="value"
      [id]="id"
      (click)="checkboxClicked($event)"
    >
      <ng-content *ngIf="content; else noContent"></ng-content>
      <ng-template #noContent>
        <div [ngStyle]="{ color: color }">
          {{ label | translate }}
        </div>
      </ng-template>
    </mat-checkbox>
  </div>
</ng-container>
